import { render, staticRenderFns } from "./Figure.vue?vue&type=template&id=aade374e&scoped=true&"
import script from "./Figure.vue?vue&type=script&lang=js&"
export * from "./Figure.vue?vue&type=script&lang=js&"
import style0 from "./Figure.vue?vue&type=style&index=0&id=aade374e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aade374e",
  null
  
)

export default component.exports